import React from 'react'
import { Card, Button, Typography, Space, Row, Col } from 'antd'
import {
  FileTextOutlined,
  UserOutlined,
  TeamOutlined,
  MedicineBoxOutlined,
  CalendarOutlined,
  BarChartOutlined
} from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import coreReducer from '../../../../core/utils/reducer'
import CoreEnums from '../../../../core/utils/enums'
import PatientFileViewer from './PatientFileViewer'

const { Title, Text, Paragraph } = Typography

const PatientFileLanding = () => {
  const dispatch = useDispatch()
  const authState = useSelector((state) => state.auth)
  const currentPatient = authState.agiliteUser

  const handleViewFile = () => {
    // Open the patient file viewer in a new tab
    dispatch(
      coreReducer.actions.addTab({
        key: `${CoreEnums.tabKeys.MY_PATIENT_FILE}_viewer`,
        closable: true,
        label: 'My Patient File',
        children: <PatientFileViewer />
      })
    )
  }

  const fileFeatures = [
    {
      icon: <UserOutlined style={{ fontSize: '24px', color: '#1890ff' }} />,
      title: 'Personal Information',
      description: 'View and manage your personal details, contact information, and medical aid details'
    },
    {
      icon: <TeamOutlined style={{ fontSize: '24px', color: '#52c41a' }} />,
      title: 'Family Members',
      description: 'Access dependant profiles and manage family medical information'
    },
    {
      icon: <MedicineBoxOutlined style={{ fontSize: '24px', color: '#722ed1' }} />,
      title: 'Prescriptions',
      description: 'View your current and past prescriptions, dosages, and medication history'
    },
    {
      icon: <FileTextOutlined style={{ fontSize: '24px', color: '#fa8c16' }} />,
      title: 'Medical Documents',
      description: 'Access lab results, medical certificates, and other important documents'
    },
    {
      icon: <CalendarOutlined style={{ fontSize: '24px', color: '#eb2f96' }} />,
      title: 'Appointment History',
      description: 'View past and upcoming appointments with your healthcare providers'
    },
    {
      icon: <BarChartOutlined style={{ fontSize: '24px', color: '#13c2c2' }} />,
      title: 'Health Analytics',
      description: 'Track your health trends and view personalized health insights'
    }
  ]

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      {/* Header Section */}
      <Card
        style={{
          marginBottom: '24px',
          borderRadius: '12px',
          background: 'linear-gradient(135deg, #1890ff 0%, #40a9ff 100%)',
          border: 'none'
        }}
      >
        <div style={{ color: 'white', textAlign: 'center' }}>
          <Title level={2} style={{ color: 'white', margin: '0 0 16px 0' }}>
            My Patient File
          </Title>
          <Paragraph style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '16px', margin: '0 0 24px 0' }}>
            Welcome, {currentPatient?.firstName} {currentPatient?.lastName}
          </Paragraph>
          <Paragraph style={{ color: 'rgba(255, 255, 255, 0.75)', fontSize: '14px', margin: '0 0 32px 0' }}>
            Access your complete medical information, appointment history, prescriptions, and more in one secure
            location.
          </Paragraph>
          <Button
            type='primary'
            size='large'
            onClick={handleViewFile}
            style={{
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              border: '2px solid white',
              color: 'white',
              fontWeight: 'bold',
              height: '48px',
              padding: '0 32px',
              borderRadius: '24px'
            }}
          >
            <FileTextOutlined style={{ marginRight: '8px' }} />
            View My File
          </Button>
        </div>
      </Card>

      {/* Features Overview */}
      <Card
        title="What's in Your Patient File"
        style={{ borderRadius: '12px' }}
        headStyle={{
          backgroundColor: '#bae7ff',
          fontWeight: 'bold',
          borderRadius: '12px 12px 0 0',
          borderBottom: '1px solid #91d5ff'
        }}
        bodyStyle={{ backgroundColor: '#e6f7ff', padding: '24px', borderRadius: '0 0 12px 12px' }}
      >
        <Row gutter={[24, 24]}>
          {fileFeatures.map((feature, index) => (
            <Col xs={24} md={12} lg={8} key={index}>
              <Card
                style={{
                  height: '100%',
                  borderRadius: '8px',
                  border: '1px solid #d9d9d9',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer'
                }}
                bodyStyle={{ padding: '20px' }}
                hoverable
              >
                <Space direction='vertical' size='middle' style={{ width: '100%' }}>
                  <div style={{ textAlign: 'center' }}>{feature.icon}</div>
                  <Title level={5} style={{ textAlign: 'center', margin: 0 }}>
                    {feature.title}
                  </Title>
                  <Text type='secondary' style={{ textAlign: 'center', display: 'block' }}>
                    {feature.description}
                  </Text>
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
      </Card>
    </div>
  )
}

export default PatientFileLanding
